// extracted by mini-css-extract-plugin
export var st0 = "lift-module--st0--d1FD0";
export var svgElem1 = "lift-module--svg-elem-1--2OFHe";
export var active = "lift-module--active--3xyrZ";
export var svgElem2 = "lift-module--svg-elem-2--3uNPh";